class StickyProductBar extends HTMLElement {
    constructor() {
      super();
      this.observeSections = this.observeSections.bind(this);
      this.handleVariantUpdate = this.handleVariantUpdate.bind(this);
    }
  
    connectedCallback() {
      this.productSection = document.getElementById('main-product-section');
      this.navLinks = this.querySelectorAll('.section-tab');
      this.productCard = this.closest('product-card');
      this.stickyProductVariant = this.querySelector('.sticky-bar-variant');

      if (this.stickyProductVariant && this.productCard) {
        this.observeVariantChanges();
      }

      if (this.productSection) {
        this.addToCartButton = this.productSection.querySelector('button[type="addToCart"]');
        if (this.addToCartButton) {
          this.initAddToCartObserver();
        }
      }
  
      const sectionIds = Array.from(this.navLinks)
        .map((link) => link.getAttribute('href'))
        .filter((href) => href && href.startsWith('#'))
        .map((href) => document.querySelector(href))
        .filter((section) => section);
  
      this.sections = sectionIds;
  
      if (this.sections.length > 0) {
        this.initObserver();
      }
    }
  
    disconnectedCallback() {
      if (this.observer) {
        this.sections.forEach((section) => this.observer.unobserve(section));
      }
      if (this.addToCartObserver) {
        this.addToCartObserver.disconnect();
      }
      if (this.variantObserver) {
        this.variantObserver.disconnect();
      }
    }

    initAddToCartObserver() {
      this.addToCartObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('active-sticky');
          } else {
            this.classList.add('active-sticky');
          }
        });
      }, { threshold: 0 });

      this.addToCartObserver.observe(this.addToCartButton);
    }
  
    initObserver() {
      this.observer = new IntersectionObserver(this.observeSections, {
        threshold: 0.6,
      });
  
      this.sections.forEach((section) => {
        this.observer.observe(section);
      });
    }
  
    observeSections(entries) {
      entries.forEach((entry) => {
        const id = entry.target.id;
  
        if (entry.isIntersecting) {
          this.navLinks.forEach((link) => {
            link.classList.remove('active-section');
            if (link.getAttribute('href') === `#${id}`) {
              link.classList.add('active-section');
            }
          });
        }
      });
    }
  
    observeVariantChanges() {
      this.variantObserver = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-product-card-selected_variant') {
            this.handleVariantUpdate();
          }
        }
      });
  
      this.variantObserver.observe(this.productCard, {
        attributes: true,
        attributeFilter: ['data-product-card-selected_variant'],
      });
    }
  
    handleVariantUpdate() {
      const variant = this.productCard.getAttribute('data-product-card-selected_variant');
      if (!variant) return;
  
      try {
        const variantData = JSON.parse(variant);
        this.stickyProductVariant.textContent = variantData.title;
      } catch (error) {
        console.error('Failed to parse variant data:', error);
      }
    }
}
  
window.customElements.define('sticky-product-bar', StickyProductBar);  